import { Injectable } from '@angular/core';
import { ENGAGE_BASE_URL } from '../settings/routes';

@Injectable()
export class EngageLinkProvider {
  getEventLink(id: string) {
    return `${ENGAGE_BASE_URL}/${id}`;
  }
}
